var _path, _path2, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArtSuccessGeneral = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 329,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h328v172H.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6EFE3",
  fillRule: "evenodd",
  d: "M149.145 42.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.623-58.698-60.689 1.531-27.357 38.565-27.82 64.193-37.512Z",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 164.5,
  cy: 90,
  r: 45,
  fill: "#56893E"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 9,
  d: "m148.223 94.485 9.796 9.877 26.587-26.809"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F56B57",
  fillRule: "evenodd",
  stroke: "#F56B57",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.5,
  d: "M230.721 50.236c8.511 1.318 15.225 8.032 16.543 16.543.045.297.422.297.47 0 1.318-8.51 8.032-15.225 16.543-16.543.297-.045.297-.422 0-.47-8.511-1.317-15.225-8.032-16.543-16.543-.045-.297-.422-.297-.47 0-1.318 8.51-8.032 15.226-16.543 16.543-.295.045-.295.425 0 .47ZM79.656 131.166a14.005 14.005 0 0 1 11.676 11.677c.033.209.299.209.333 0a14.005 14.005 0 0 1 11.676-11.677c.21-.032.21-.298 0-.332a14.005 14.005 0 0 1-11.676-11.677c-.033-.209-.299-.209-.333 0a14.005 14.005 0 0 1-11.676 11.677c-.208.032-.208.3 0 .332Z",
  clipRule: "evenodd"
})));
export default SvgArtSuccessGeneral;